export default {
      id: "flexible-investment-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#flexible-investment",
      toString: function () {
        return this.url;
      }
    }